import { css } from 'lit';

export const styles = css`:host{--menu-mini-width: 3rem}:host [part=overlay]{background:var(--background-color)}:host [part=mini],:host [part=main]{padding:.5rem}`;
